import TR from 'utils/TR';
import usePeriodAction from 'hooks/actions/usePeriodAction';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';
import React from 'react';
import * as Luxon from 'luxon';

export default function PeriodOffsetButton(props) {
  const {
    days,
    label,
    basis,
    selection,
    onTrigger,
    ...rest
  } = props || {};

  const fixedDays = React.useMemo(() => Math.sign(days) * (Math.abs(days) - 1), [days]);

  return (
    <FocusableButton
      {...ex(['PeriodButton', 'PeriodOffsetButton'], rest)}
      {...{
        onClick: onTrigger(fixedDays),
      }}
    >
      {0 < Math.abs(days) && T('{0}일', label || Math.abs(days))}
      {!days && label}
    </FocusableButton>
  );
}
